<div class="dashboard-container">

  <div class="dashboard-grid">

    <!-- LEFT COLUMN: INFO -->
    <section class="info-column">
      <h2>Grenada Transport Information</h2>

      <p class="intro-text">
        This system provides centralized access to vehicle registration,
        inspections, ownership records and future transport-related services
        managed in Grenada.
      </p>

      <iframe
        src="https://moi.gd/"
        title="Grenada Ministry of Infrastructure"
        class="transport-info-iframe">
      </iframe>
    </section>

    <!-- RIGHT COLUMN: OPTIONS -->
    <section class="cards-column">

      <div class="cards-grid">

        <div class="card-block mat-elevation-z3" (click)="go('vehicles')">
          <img src="assets/imatges/grenada_dash_veh.jpg" alt="Vehicles">
          <div class="card-content">
             <h3><mat-icon  color="primary" style="font-size:24px">commute</mat-icon> Vehicles</h3>
            <p>
              Manage vehicle records, registration details, technical data
              and operational status.
            </p>
          </div>
        </div>

        <div class="card-block mat-elevation-z3" (click)="go('inspections')">
          <img src="assets/imatges/grenada_dash_insp.jpg" alt="Inspections">
          <div class="card-content">
            <h3><mat-icon  color="primary" style="font-size:24px">engineering</mat-icon> Inspections</h3>
            <p>
              Track annual inspections, compliance status and inspection history
              for all registered vehicles.
            </p>
          </div>
        </div>

        <div class="card-block mat-elevation-z3" (click)="go('owners')">
          <img src="assets/imatges/grenada_dash_owners.png" alt="Owners">
          <div class="card-content">
            <h3><mat-icon  color="primary" style="font-size:24px">badge</mat-icon> Owners</h3>
            <p>
              Access vehicle ownership data, contact details and ownership changes.
            </p>
          </div>
        </div>

        <div class="card-block mat-elevation-z3" (click)="go('accidents')">
          <img src="assets/imatges/grenada_dash_accident.png" alt="Accidents">
          <div class="card-content">
            <h3><mat-icon  color="primary" style="font-size:24px">car_crash</mat-icon> Accidents</h3>
            <p>
              Future module for accident reporting, statistics and incident tracking.
            </p>
          </div>
        </div>

        <div class="card-block mat-elevation-z3" (click)="go('insurances')">
          <img src="assets/imatges/grenada_dash_insurance.jpg" alt="Insurances">
          <div class="card-content">
            <h3><mat-icon  color="primary" style="font-size:24px">assignment_ind</mat-icon> Insurances</h3>
            <p>
              Planned integration with insurance providers and policy verification.
            </p>
          </div>
        </div>

        <div class="card-block mat-elevation-z3" (click)="go('licenses')">
          <img src="assets/imatges/grenada_dash_licenses.jpg" alt="Licenses">
          <div class="card-content">
            <h3><mat-icon  color="primary" style="font-size:24px">description</mat-icon> Licenses</h3>
            <p>
              Centralized tracking of operating licenses, and owner assignments.
            </p>
          </div>
        </div>

        <div class="card-block mat-elevation-z3" (click)="go('busstops')">
          <img src="assets/imatges/grenada_dash_bus_stop.jpg" alt="Bus stops">
          <div class="card-content">
            <h3><mat-icon  color="primary" style="font-size:24px">directions_bus</mat-icon> Bus stops</h3>
            <p>
              Centralized tracking of operating licenses, and owner assignments.
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>

  <app-footer></app-footer>

</div>
